import { createSelector } from "reselect";
import { getTranslate } from "assets/titles/title-text";

const getMetrics = (state) => {
    return state.ExtendedAnalytic.metric;
}

const checkData = (analytics, d) => {
    d.topicIDs = analytics && analytics.topicId ? analytics.topicId : [];
    d.chartType = analytics && analytics.chartType ? analytics.chartType : [];
    d.pageType = analytics && analytics.pageType ? analytics.pageType : null;
    d.title = analytics && analytics.chartSettings ? analytics.chartSettings.title : '';
    d.height = analytics && analytics.chartSettings ? analytics.chartSettings.height : 290;
    d.width = analytics && analytics.chartSettings ? analytics.chartSettings.width : '100%';
    d.chartId = analytics && analytics.type ? analytics.type : null;
    d.max = analytics && analytics.chartSettings && analytics.chartSettings.max ? analytics.chartSettings.max : null;
    d.position = analytics && analytics.chartSettings && analytics.chartSettings.position ? analytics.chartSettings.position : null;

    return d
}

export const getExtendedMetric = createSelector(getMetrics, (analytics) => {
    
    let d = {data: [], values: [], labels: [], colors: null, topicIDs: [], chartType: null, title: '', isChanges: true, position: analytics}
    d = checkData(analytics, d)
    return d
})